import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import type { PostSummary } from "@/lib/site";

export interface Season {
  key: string; name: string; cta: string; kicker: string; headline: string; note: string; accent: string; tint: string;
  doodles: string[]; sections: string[]; image: string | null; featured: PostSummary[]; preview: boolean;
}

const cache: Record<string, Promise<Season>> = {};
const load = (key: string): Promise<Season> => {
  if (!cache[key]) {
    cache[key] = api.get("/public/season", { params: key ? { season: key } : {} }).then((r) => r.data)
      .catch((e) => { delete cache[key]; if (key) return load(""); throw e; });
  }
  return cache[key];
};

// ?season=<key> on any page previews another season (handy from the admin Seasons page).
export function useSeason() {
  const [sp] = useSearchParams();
  const key = sp.get("season") || "";
  const [season, setSeason] = useState<Season | null>(null);
  useEffect(() => {
    let live = true;
    load(key).then((s) => { if (live) setSeason(s); }).catch(() => { if (live) setSeason(null); });
    return () => { live = false; };
  }, [key]);
  return season;
}
